import React, { Suspense, useContext, useEffect, useRef, useState } from 'react';
import { useLocalizePath, useT } from '../../../../helpers/i18n';

import {faArrowDown} from '@fortawesome/pro-regular-svg-icons'

import * as appContext from '../../../../components/AppContext';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDispatch, useSelector} from "react-redux";
import {fetchPropertiesAction} from "../../../../redux/actions";
import Checkers from "../../../../helpers/class/Checkers";
import {fetchBuilderSettingByKey} from "../../../../helpers/MethodHelper";
import ArticleTypes from "../../articles/ArticleTypes";

import cloneDeep from 'lodash/cloneDeep';
import Skeleton from "react-loading-skeleton";

interface PropertiesSectionProps {
  title?: string
  subtitle?: string
  limit?: number
  backgroundColor?: string
  darkMode?: number
  showAll?: number
  showAllLabel?: string
  app_data?: any
  builder?: any
  app?: any
}

export default function PropertiesSection ({ title, subtitle, limit, backgroundColor, darkMode, showAll, showAllLabel, app_data, builder, app } : PropertiesSectionProps) {
  const t = useT();

  const localizePath = useLocalizePath();

  const dispatch = useDispatch()

  const [properties, setProperties] = useState([])

  const [triedAllPropertiesFallback, setTriedAllPropertiesFallback] = useState(false)

  const propertiesParams = useSelector(state => state['propertiesParams']);


  const requestIdRef = useRef(0)

  const propertiesFetchHandler = async (featuredOnly = true) => {
    const requestId = ++requestIdRef.current

    let params = cloneDeep(propertiesParams)
    params.limit = limit
    if (featuredOnly) {
      params.is_featured = 1
    }

    const result : any = await dispatch<any>(fetchPropertiesAction(params))

    if (requestId !== requestIdRef.current) return

    if (Checkers.isValidArray(result?.properties)) {
      setTriedAllPropertiesFallback(!featuredOnly)
      setProperties(result.properties.slice(0, limit))
      if (result.properties.length > limit) {
        dispatch({ type: 'fetchProperties', data: { ...result, properties: result.properties.slice(0, limit) } })
      }
    } else if (featuredOnly) {
      setTriedAllPropertiesFallback(true)
      propertiesFetchHandler(false)
    } else {
      setProperties([])
    }
  }

  const propertyItemClass = (count : number) => {
    if (count % 4 == 0 && count > 0) {
      return 'col-md-6'
    }
    if (count % 2 == 0) {
      return 'col-md-6'
    }
    return 'col-md-4'
  }

  const textColor = () => {
    if (darkMode == 1) {
      return "text-light-color"
    }

    return ""
  }

  useEffect( () => {
    propertiesFetchHandler(true)
  }, [])

  const getItemUrl = (property) => {
    let url = Checkers.isValidString(property.sourcePath) ? property.sourcePath : (Checkers.isValidString(property.urlSlug) ? property.urlSlug : '/property/' + property.property_id )
    // a bare slug ("Villa-Rogdia") is made root-relative so the language prefix can be added
    if (!/^(https?:)?\/\/|^\/|^#/.test(url)) {
      url = '/' + url
    }
    return localizePath(url)
  }

  const builderPropertiesViewType = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_properties_view_type')
  ) || '407'

  const prepareProperties = () => {
    return properties.map((property) => ({
      id: property.property_id,
      title: property.property_title,
      subtitle: '',
      loggiaUrl: getItemUrl(property),
      redirect_url: getItemUrl(property),
      image: Checkers.isValidArray(property.featured_images) ? property.featured_images[0] : null,
      has_description: 0
    }))
  }

  return (
      <>
        {
          <>
            {
              Checkers.isValidString(title) || Checkers.isValidString(subtitle) ?
                  <>
                    <section className={" p-b-20 p-t-20"} style={{background: Checkers.isHexColor(backgroundColor) ? backgroundColor : ''}}>
                      <div className="container text-center">
                        <div className="row">
                          <div className="col-sm-8 offset-sm-2">
                            {Checkers.isValidString(subtitle) ?<h6 className={textColor() + " block-title m-b-0"}>{subtitle}</h6> : <></>}
                            {Checkers.isValidString(title) ? <h1 className={textColor() + " m-t-5 light"}>{title}</h1> : <></>}
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                  :
                  <></>
            }
            {
              properties != undefined && Checkers.isValidArray(properties) ?
                  <>
                    {
                      builderPropertiesViewType == '402' ?
                          <section className="container-fluid b-t b-white p-0" style={{background: Checkers.isHexColor(backgroundColor) ? backgroundColor : ''}}>
                            <div className="row m-auto">
                              {
                                properties.map( (property, index) => {
                                  if (index>(limit-1)) {
                                    return (
                                        <></>
                                    )
                                  }

                                  return (
                                      <>
                                        <a href={ getItemUrl(property) }
                                           className={ propertyItemClass(properties.length) + " text-center bg-success hover-push demo-story-block properties_div"}
                                           style={{height: "350px", cursor: "pointer", border: "1px white solid"}}>

                                          <div className="hover-backdrop"
                                               style={{backgroundImage: property.featured_images?.[0] ? 'url('+property.featured_images[0]+')' : 'none'}}
                                          ></div>
                                          <div className="hover-caption bottom-left bottom-right p-b-40">
                                            <h4 className="text-white m-b-5 properties_title">{property.property_title}</h4>
                                            <a
                                                href={ getItemUrl(property) }
                                                className="fs-12 hint-text text-white all-caps">{t('properties.moreDetails')}</a>
                                          </div>

                                        </a>
                                      </>
                                  )
                                })
                              }
                            </div>
                          </section>
                          :
                          <ArticleTypes
                              type={'properties'}
                              textColor={textColor()}
                              darkMode={darkMode == 1}
                              backgroundColor={backgroundColor}
                              content={''}
                              articles={prepareProperties().slice(0, limit)}
                              app={app}
                              app_data={app_data}
                              builder={builder}
                              viewType={builderPropertiesViewType}
                              articlesCategories={null}
                              articlesLimit={null}
                              isFeaturedOnly={!triedAllPropertiesFallback}
                          />
                    }
                  </>
                  :
                  <>

                    <section className="container-fluid b-t b-white p-0" style={{background: Checkers.isHexColor(backgroundColor) ? backgroundColor : ''}}>
                      <div className="row">
                        <Skeleton height={350} className="col-md-4" />
                      </div>
                    </section>
                  </>
            }
            {
              showAll == 1 ?
                  <>
                    <section className={" p-b-100 p-t-40"} style={{background: Checkers.isHexColor(backgroundColor) ? backgroundColor : ''}}>
                      <div className="container text-center">
                        <div className="row justify-content-center">
                          <div className={"col-auto text-center"}>
                            <a className={'btn btn-primary btn-design-color p-4 p-t-10 p-b-10'} href={'/properties/all'}>
                              {
                                Checkers.isValidString(showAllLabel) ?
                                    <>{showAllLabel}</>
                                    :
                                    <>{t('common.showAll')}</>
                              }
                            </a>
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                  :
                  <></>
            }
          </>
        }
      </>
  )
}